import React, { useState } from 'react'
import VipOnlyPopup from '@/components/shared/livemallclub/VipOnlyPopup'

const useVipOnlyPopup = () => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  const PopupComponent = () => {
    return <VipOnlyPopup isOpen={isOpen} handleClose={handleClose} />
  }

  return { PopupComponent, handleOpen, handleClose }
}

export default useVipOnlyPopup
